module.exports = __webpack_public_path__ + "img/num2.7c6a4c89.png";